import React, { useEffect, useState, useContext } from "react";
import {
  Switch,
  Route,
} from "react-router-dom";

import { db } from "./Firebase";
import { ref, off, onValue, query } from "firebase/database";
//axios and base url
import axios from "axios";
import {
  BASE_URL,
  SAAS_APPLICATION,
  saas_apiUrl,
  saas_apiParams,
  saas_form_data,
} from "./BaseUrl";
//routes
import RestaurantRoute from "./routes/RestaurantRoute";
import CustomerRoute from "./routes/CustomerRoute";
import PosOrderRoute from "./routes/PosOrderRoute";

//functions
import {
  checkPermission,
  getSystemSettings,
} from "./functions/Functions";

//3rd party packages
import { ToastContainer } from "react-toastify";

//pages & includes
import {
  //installation
  Welcome,
  InstallPermission,
  DbSetup,
  ImportDb,
  InstallationUser,
  InstallationCongratulation,
  //landing
  RestaurantLanding,
  CustomerProfile,
  MyOrders,
  DigitalMenu,

  //common
  Refresh,
  Login,
  SignUp,
  BeDeliveryMan,
  NotFound,
  ForgetPw,
  SetNewPw,
  NoPermission,

  //dashboard
  RestaurantHome,
  UpdateProfile,
  WorkPeriod,
  OpeningClosingStock,

  //delivery
  AssignedOrders,
  DeliveredOrders,

  //pos
  Pos,
  Submitted,
  FoodPanda,
  Settled,
  OnlineOrders,
  PreOrders,
  EditSubmittedOrder,
  //customers
  Customers,
  OnlineCustomerList,
  //
  OnlineOrderHistories,
  OrderHistories,
  Kitchen,
  KitchenOnline,

  //Reports
  Dashboard,
  TableDashboard,
  AdminDashboard,
  CostingDashboard,
  ConsolitedData,
  ConsolitedReport,
  Daily,
  Monthly,
  // Yearly,
  ItemWise,
  GroupWise,
  BranchWise,
  UserWise,
  DeptWise,
  ServiceChargeWise,
  DiscountReport,
  CombinedDiscountReport,
  SalesTenderReport,
  StockDashboard,
  FoodStockReport,
  IngredientStockReport,
  OpeningClosingStockIngredientReport,
  OpeningClosingStockFoodReport,
  WorkPeriodReport,
  SalesReport,
  OrderTracking,
  SalesSummaryReport,
  FocReport,
  GrossSalesReport,
  SalesSyncReport,
  SourceWiseReport,
  CustomerOrderHistoryReport,
  FoodPandaReport,
  RiderReport,
  WaiteReport,
  FeedbackReport,
  CancelOrderReport,
  CancelItemReport,
  MeezanReport,
  HourlySalesReport,
  IncomeStatementReport,
  DailyCashSalesReport,
  ExpenseReport,
  StockTransferReport,
  StockIssuanceReport,
  StoreRequisitionReport,
  GRNReport,
  PurchaseOrderReport,
  PurchaseRequestReport,
  StockAdjustmentReport,
  IngredientConsumptionReport,
  IngredientConversionReport,
  FGSaleOrderInvoiceReport,
  FGSaleInvoiceReport,
  OpeningReport,
  CommisionReport,
  SaleReturnReport,
  WastageReport,
  IngredientCostReport,
  ClosingStockReport,
  PurchaseReturnReport,
  RcrReport,
  PoToPiReport,
  InvoiceAgeingReport,
  StockConsumptionPurchaseVarianceReport,
  MultiBranchAnalysis,

  //manage->food
  GroupCrud,
  UnitCrud,
  VariationCrud,
  PropertyCrud,
  PropertyItemCrud,
  FoodItemCrud,
  FoodDepartmentList,
  FoodDepartmentAction,
  FoodItemMenuBranchLink,
  MealTimeList,
  MealTimeAction,
  AllItemList,
  FoodItemDeptList,
  FoodStatusList,
  CommentsList,
  CommentAction,
  RegionList,
  RegionAction,
  SubCategoryList,
  SubCategoryAction,
  PackingTypeList,
  PackingTypeAction,
  NewFoodItemDeptAction,
  TaxGroupList,
  TaxGroupAction,
  StoreRequisitionDept,
  StoreRequisitionDeptAction,

  //manage->website
  HeroSection,
  Promotions,
  //manage->settings
  Currency,
  Lang,
  Translation,
  GenerateTestController,
  Smtp,
  PosScreen,
  OrderDelivery,
  General,
  WebMapping,
  OfflineTableSync,
  UpdateSystem,
  CurrencyNoteCrud,
  CurrencyNoteAction,

  //manage->stock
  FoodPurchase,
  FoodPurchaseEdit,
  FoodPurchaseHistory,
  FoodReturn,
  GatePassList,
  GatePassAction,
  IngredientGroup,
  IngredientItem,
  IngredientLimitAction,
  IngredientItemLimit,
  IngredientPurchase,
  IngredientPurchaseEdit,
  IngredientPurchaseHistory,
  SaleInvoiceAction,
  SaleInvoiceList,
  PurchaseReturnList,
  PurchaseReturnAction,
  PurchaseRequestHistory,
  PurchaseRequestAction,
  StockConsumptionList,
  StockConsumptionAction,
  PurchaseOrderAction,
  PurchaseOrderHistory,
  FgSaleReturnList,
  FgSaleReturnAction,
  FgSaleOrderList,
  FgSaleOrderAction,
  SaleReturnList,
  SaleReturnAction,
  GoodsReceivedNoteAction,
  GoodsReceivedHistory,
  GRNDeptList,
  GRNDeptAction,
  IngredientUsage,
  IngredientReturn,
  ManageSupplier,
  SupplierAction,
  SupplierHistory,
  StockOutFood,
  StockOutIngredient,
  RecipeEdit,
  ProductionAction,
  ProductionList,
  ProductTypeList,
  FinishGoods,
  EditFinishGoods,
  FinishGoodsHistory,
  FgRequisitionList,
  FgRequisitionAction,
  StockIssuanceDept,
  StockIssuanceDeptAction,
  BrandList,
  BrandAction,
  ClosingStockHistory,
  ClosingStockAction,

  //manage->user
  AdminStaffCrud,
  UserTill,
  UserTillAction,
  DeliveryMen,
  NewDeliveryMen,
  Waiter,
  Permissions,
  CustomerCrud,

  //manage->restaurantDetails
  BranchCrud,
  MDIntegrationAction,
  MDIntegrationList,
  MdJv,
  Zone,
  ZoneAction,
  LocationList,
  LocationAction,
  ReasonList,
  ReasonAction,
  OrderTypeCrud,
  TableFloor,
  TableCrud,
  MenuTagCrud,
  PaymentTypeCrud,
  BankNameCrud,
  KotCrud,
  CreateRecipe,
  BulkRecipeUpdate,
  ViewRecipe,
  IngredientUnit,

  //accounts
  AccountSettings,
  ChartAccount1,
  ChartAccount2,
  ChartAccount3,
  Expense,
  AddNewComplaint,
  ComplaintBoard,
  ComplaintTickets,
  ComplaintResolve,
  ComplaintReport,
  TicketsList,
  ResolvedTicketsList,
  VoucherCrud,
  // acc report
  AccountsReport,
  TrialBalanceReport,
  ProfitAndLossReport,
  SalesFlowReport,
  BalanceSheetReport,

  //payroll
  Department,
  DepartmentAction,
  Designation,
  DesignationAction,

  FGPurchaseList,
  FgPurchaseReport,
  FgInvoceAction,
  BankDropList,
  BankDropForm,
  BankDropReport,
  SalesAnalysisReport,
  SupplierPurchaseReport,
  ActualIdealCostReport,
  StockReceiving,
  StockReceivingAction,
  GiftHampersReturn,
  GiftHampersReturnAction,
  MovingAvg,
  Areas,
  RcrList,
  RcrLeaderboardReport,
  RcrAuditAction,
  RcrQuestionList,
  RcrQuestionAction,
  WeeklySalesReport,
  LocationSetup,
} from "./imports/Pages";

import { Navbar, Footer } from "./imports/Components";
import ExpenseList from "./resources/restaurant/auth/expense/ExpenseList";
//context consumer
import { SettingsContext } from "./contexts/Settings";
import { UserContext } from "./contexts/User";
import Showdeliveryman from "./resources/restaurant/auth/manage/settings/ShowDeliveryman";
import NotPermitted from "./saasHelper/NotPermitted";
import { SaasContext } from "./contexts/SaasHelper";
import SaasProfile from "./resources/restaurant/auth/saasInfo/SaasProfile";
import SaasApiFailure from "./saasHelper/saasApiFailure";
import ShowManageStock from "./resources/restaurant/auth/manage/settings/ShowManageStock";
import UpdateSettings from "./resources/restaurant/auth/manage/settings/UpdateSettings";
import Blocked from "./saasHelper/Blocked";
import TopBarOffline from "./TopBarOffline";
import OnlinePayment from "./resources/restaurant/auth/manage/settings/OnlinePayment";
import PartyHistory from "./resources/restaurant/auth/manage/restaurantDetails/PartyHistory";
import Party from "./resources/restaurant/auth/manage/restaurantDetails/PartyCrud";
import SchemesCrud from "./resources/restaurant/auth/manage/food/SchemesCrud";
import CardsCrud from "./resources/restaurant/auth/manage/food/CardsCrud";
import AddonRestrictionsCrud from "./resources/restaurant/auth/manage/food/AddonRestrictionsCrud";
import StockTransfer from "./resources/restaurant/auth/manage/stock/StockTransfer";
import StockLedgerReport from "./resources/restaurant/auth/reports/StockLedgerReport";
import SupplierLedgerReport from "./resources/restaurant/auth/reports/SupplierLedgerReport";
import StockVarianceReport from "./resources/restaurant/auth/reports/StockVarianceReport";
import StockConsumptionReport from "./resources/restaurant/auth/reports/StockConsumptionReport";
import EmailTemplate from './resources/restaurant/auth/manage/settings/Email';
import FoodItemEdit from "./resources/restaurant/auth/manage/food/FoodItemEdit";
import BankPayment from "./resources/restaurant/auth/accounts/transactions/BankPayment";
import CashPayment from "./resources/restaurant/auth/accounts/transactions/CashPayment";
import JournalVoucher from "./resources/restaurant/auth/accounts/transactions/JournalVoucher";
import OpeningAccount from "./resources/restaurant/auth/accounts/transactions/OpeningAccount";
import AddBankPayment from "./resources/restaurant/auth/accounts/transactions/AddBankPayment";
import EditBankPayment from "./resources/restaurant/auth/accounts/transactions/EditBankPayment";
import AddCashPayment from "./resources/restaurant/auth/accounts/transactions/AddCashPayment";
import AddJournalVoucher from "./resources/restaurant/auth/accounts/transactions/AddJournalVoucher";
import EditCashPayment from "./resources/restaurant/auth/accounts/transactions/EditCashPayment";
import EditJournalVoucher from "./resources/restaurant/auth/accounts/transactions/EditJournalVoucher";
import StockTransferAdd from "./resources/restaurant/auth/manage/stock/StockTransferAdd";
import OpeningStock from "./resources/restaurant/auth/manage/stock/OpeningStock";
import OpeningStockEdit from "./resources/restaurant/auth/manage/stock/OpeningStockEdit";
import OpeningStockAdd from "./resources/restaurant/auth/manage/stock/OpeningStockAdd";
import StockTransferView from "./resources/restaurant/auth/manage/stock/StockTransferView";
import StoreRequisition from "./resources/restaurant/auth/manage/stock/StoreRequisition";
import StoreRequisitionAction from "./resources/restaurant/auth/manage/stock/StoreRequisitionAction";
import StockAdjustment from "./resources/restaurant/auth/manage/stock/StockAdjustment";
import StockAdjustmentAdd from "./resources/restaurant/auth/manage/stock/StockAdjustmentAdd";
import BranchAction from "./resources/restaurant/auth/manage/restaurantDetails/BranchAction";
import SchemeCrudAction from "./resources/restaurant/auth/manage/food/SchemeCrudAction";
import PartyAction from "./resources/restaurant/auth/manage/restaurantDetails/PartyAction";
import AddOpeningAccount from "./resources/restaurant/auth/accounts/transactions/AddOpeningAccount";
import EditOpeningAccount from "./resources/restaurant/auth/accounts/transactions/EditOpeningAccount";
import LedgerReport from "./resources/restaurant/auth/accounts/accountsReport/LedgerReport";
import AccountsSupplierLedgerReport from "./resources/restaurant/auth/accounts/accountsReport/AccountsSupplierLedgerReport";
import FinishGoodTransfer from "./resources/restaurant/auth/manage/stock/FinishGoodTransfer";
import FinishGoodTransferAdd from "./resources/restaurant/auth/manage/stock/FinishGoodTransferAdd";
import FinishGoodTransferEdit from "./resources/restaurant/auth/manage/stock/FinishGoodTransferEdit";
import FinishedGoodsDiscardEdit from "./resources/restaurant/auth/manage/stock/FinishedGoodsDiscardEdit";
import FinishedGoodsDiscardAdd from "./resources/restaurant/auth/manage/stock/FinishedGoodsDiscardAdd";
import FinishedGoodsDiscard from "./resources/restaurant/auth/manage/stock/FinishedGoodsDiscard";
import FinishGoodsAcceptance from "./resources/restaurant/auth/manage/stock/FinishGoodsAcceptance";
import FinishGoodsAcceptanceView from "./resources/restaurant/auth/manage/stock/FinishGoodsAcceptanceView";
import FinishedGoodsReport from "./resources/restaurant/auth/reports/FinishedGoodsReport";
import InventoryReport from "./resources/restaurant/auth/reports/InventoryReport";
import DealReport from "./resources/restaurant/auth/reports/DealReport";
import CompleteSales from "./resources/restaurant/auth/reports/CompleteSales";
import AdminReport from "./resources/restaurant/auth/reports/AdminReport";
import CallCenterReport from "./resources/restaurant/auth/reports/CallCenterReport";
import DayEndSetting from "./resources/restaurant/auth/manage/stock/DayEndSetting";
import DayEndSettingAdd from "./resources/restaurant/auth/manage/stock/DayEndSettingAdd";
import FgPackageHistory from "./resources/restaurant/auth/manage/stock/FgPackageHistory";
import FgPackingAction from "./resources/restaurant/auth/manage/stock/FgPackingAction";
import GiftHampers from "./resources/restaurant/auth/manage/stock/GiftHampers";
import GiftHampersAction from "./resources/restaurant/auth/manage/stock/GiftHampersAction";
import FinishGoodsAdjustment from "./resources/restaurant/auth/manage/stock/FinishGoodsAdjustment";
import FinishGoodsAdjustmentAdd from "./resources/restaurant/auth/manage/stock/FinishGoodsAdjustmentAdd";
import FinishGoodsAdjustmentView from "./resources/restaurant/auth/manage/stock/FinishGoodsAdjustmentView";
import MenuMixReport from "./resources/restaurant/auth/reports/MenuMixReport";
import Settlement from "./resources/restaurant/auth/manage/restaurantDetails/Settlement";
import SettlementAdd from "./resources/restaurant/auth/manage/restaurantDetails/SettlementAdd";
import SettlementView from "./resources/restaurant/auth/manage/restaurantDetails/SettlementView";
import StockIssuance from "./resources/restaurant/auth/manage/stock/StockIssuance";
import StockIssuanceAction from "./resources/restaurant/auth/manage/stock/StockIssuanceAction"
import IngredientItemReport from "./resources/restaurant/auth/reports/IngredientItemReport";
import FgReport from "./resources/restaurant/auth/reports/FgReport";
import FgTransferReport from "./resources/restaurant/auth/reports/FgTransferReport";
import FgDiscardReport from "./resources/restaurant/auth/reports/FgDiscardReport";
import SrbReport from "./resources/restaurant/auth/reports/SrbReport";
import PurchaseInvoiceReport from "./resources/restaurant/auth/reports/PurchaseInvoiceReport";
import SaleInvoiceReport from "./resources/restaurant/auth/reports/SaleInvoiceReport";
import BarcodePrint from "./resources/restaurant/auth/manage/stock/BarcodePrint";
import ProductionReport from "./resources/restaurant/auth/reports/ProductionReport";
import KitchenDineIn from "./resources/restaurant/auth/kitchen/KitchenDineIn";
import KitchenTakeaway from "./resources/restaurant/auth/kitchen/KitchenTakeaway";
import KdsSettingList from "./resources/restaurant/auth/manage/restaurantDetails/KdsSettingList";
import KdsSettingAdd from "./resources/restaurant/auth/manage/restaurantDetails/KdsSettingAdd";
import KdsSettingEdit from "./resources/restaurant/auth/manage/restaurantDetails/KdsSettingEdit";
import SalesListing from "./resources/restaurant/auth/SalesListing";
import WastageFood from "./resources/restaurant/auth/manage/stock/WastageFood";
import WastageFoodAction from "./resources/restaurant/auth/manage/stock/WastageFoodAction";
import WastageFoodView from './resources/restaurant/auth/manage/stock/WastageFoodView'
import FgMomentReport from "./resources/restaurant/auth/reports/FgMomentReport";
import RawMomentReport from "./resources/restaurant/auth/reports/RawMovementReport";
import ProductionDashboard from "./resources/restaurant/auth/reports/ProductionDashboard";
import FoodItemReport from "./resources/restaurant/auth/reports/FoodItemReport";
import IngredientReport from "./resources/restaurant/auth/reports/IngredientReport";
import SupplierPayment from "./resources/restaurant/auth/manage/stock/SupplierPayment";
import SupplierPaymentAdd from "./resources/restaurant/auth/manage/stock/SupplierPaymentAdd";
import SupplierPaymentEdit from "./resources/restaurant/auth/manage/stock/SupplierPaymentEdit";
import RawStockTransferReport from "./resources/restaurant/auth/reports/RawStockTranferReport";
import CustomerReport from "./resources/restaurant/auth/reports/CustomerReport";
import FgPackingReport from "./resources/restaurant/auth/reports/FgPackingReport";
import GiftHamperReport from "./resources/restaurant/auth/reports/GiftHamperReport";
import RecipeReport from "./resources/restaurant/auth/reports/RecipeReport";
import BuildModal from "./resources/restaurant/auth/modal/BuildModal";
import CustomerScreen from "./resources/restaurant/auth/pos/CustomerScreen";
import NewPos from "./resources/restaurant/auth/pos/newpos/NewPos";
import FgAdjustmentReport from "./resources/restaurant/auth/reports/FgAdjustmentReport";
import Feedback from "./resources/common/Feedback";
import SeasonList from "./resources/restaurant/auth/manage/food/SeasonList";
import SeasonAction from "./resources/restaurant/auth/manage/food/SeasonAction";
import GenericList from "./resources/restaurant/auth/manage/food/GenericList";
import GenericAction from "./resources/restaurant/auth/manage/food/GenericActions";
import FlavorList from "./resources/restaurant/auth/manage/food/FlavorList";
import FlavorActions from "./resources/restaurant/auth/manage/food/FlavorActions";
import ProductionUnitAction from "./resources/restaurant/auth/manage/food/ProductionUnitAction";
import ProductionUnitList from "./resources/restaurant/auth/manage/food/ProductionUnitList";
import VariantList from "./resources/restaurant/auth/manage/food/VariantList";
import VariantAction from "./resources/restaurant/auth/manage/food/VariantAction";
import WeightList from "./resources/restaurant/auth/manage/food/WeightList";
import WeightAction from "./resources/restaurant/auth/manage/food/WeightAction";
import FgIssuanceList from "./resources/restaurant/auth/manage/stock/FgIssuanceList";
import FgIssuanceAction from "./resources/restaurant/auth/manage/stock/FgIssuanceAction";
import BankReceipt from "./resources/restaurant/auth/accounts/transactions/BankReceipt";
import BankRecepitForm from "./resources/restaurant/auth/accounts/transactions/BankRecepitForm";
import CashReceipt from "./resources/restaurant/auth/accounts/transactions/CashReceipt";
import CashReceiptForm from "./resources/restaurant/auth/accounts/transactions/CashReceiptForm";
import PaymentReport from "./resources/restaurant/auth/reports/PaymentReport";
import ReceiptReport from "./resources/restaurant/auth/reports/ReceiptReport";
import FgSaleInvoiceList from "./resources/restaurant/auth/manage/stock/FgSaleInvoiceList";
import FgSaleInvoiceAction from "./resources/restaurant/auth/manage/stock/FgSaleInvoiceAction";

function SaasApp() {
  // check saas subscruption expiry
  const [expiry, setExpiry] = useState(true);
  const [saasBlock, setSaasBlock] = useState(false);
  //state hooks here
  const [credentials, setCredentials] = useState({
    install_no: false,
  });
  const [isOnline, setIsOnline] = useState(true);

  //getting context values here
  const { generalSettings } = useContext(SettingsContext);
  let { authUserInfo } = useContext(UserContext);
  const [restaurantModal, setRestaurantModal] = useState(false);

  function isNotLocalIP(ip) {
    return !ip.startsWith("192.168.");
  }
  //notify firebase and update build api
  const fetchUpdatedBuild = async (endpoint) => {
    if (isNotLocalIP(endpoint)) {
      const url = `pos/${endpoint}/update-build`;
      const buildQuery = query(ref(db, url));
      // Detach any previous listeners
      off(buildQuery)
      onValue(buildQuery, (snapshot) => {
        const data = snapshot.val();
        if (data && data.status?.toLowerCase() === "notify") {
          setRestaurantModal(true)
        }
      }
      );
    }
  }

  useEffect(() => {
    if (authUserInfo?.details) {
      fetchUpdatedBuild("All");
      fetchUpdatedBuild(window.location.hostname.split('.')[0])
    }
  }, [authUserInfo])

  // check expirary function
  const handleSassExpiry = () => {
    const url = saas_apiUrl + "/api/check-expiry";
    axios
      .post(url, saas_form_data)
      .then((res) => {
        if (res.data == "YES") {
          setExpiry(true);
        } else {
          setExpiry(false);
        }
      })
      .catch(() => {
      });
  };

  // localStorage helper
  const setDataToLocal = (url, res) => {
    localStorage.setItem(url, JSON.stringify(res));
  };

  // localStorage helper
  const getDataFromLocal = (url) => {
    return JSON.parse(localStorage.getItem(url));
  };

  //check if offline helper
  const offline = (url) => {
    return !navigator.onLine && localStorage.getItem(url) != null;
  };

  // check block function
  const checkSaasBlock = () => {
    // check how many orders are left
    const url = saas_apiUrl + "/api/user-restriction?" + saas_apiParams;
    axios
      .get(url, saas_form_data)
      .then((res) => {
        setDataToLocal(url, res);
        setSaasBlock(res.data);
      })
      .catch((error) => {
        if (offline(url)) {
          let parseRes = getDataFromLocal(url);
          setSaasBlock(parseRes.data);
        }
        // return "No data found check api";
      });
  };

  const setCredential = (res) => {
    if (res.data === "NO") {
      setCredentials({
        ...credentials,
        install_no: true,
      });
    }
  };
  //useEffect == componentDidMount()
  useEffect(() => {
    // (async () => {
    //   setLoading(false);
    //   const url = BASE_URL + "/check-install";
    //   return axios
    //     .get(url)
    //     .then((res) => {
    //       setDataToLocal(url, res);
    //       setCredential(res);
    //     })
    //     .catch((error) => {
    //       if (offline(url)) {
    //         let parseRes = getDataFromLocal(url);
    //         setCredential(parseRes);
    //       }
    //     });
    // })();
    if(!authUserInfo?.details) return
    if (generalSettings) {
      const favicon = document.getElementById("favicon");
      const faviconSetting = getSystemSettings(generalSettings, "favicon");
      if (faviconSetting && faviconSetting !== "null") {
        favicon.href = BASE_URL + faviconSetting;
      }
    }

    // check expiry
    if (SAAS_APPLICATION == "YES") {
      const saasExpiryToken = setInterval(handleSassExpiry, 14400000);
      handleSassExpiry();

      const saasBlockToken = setInterval(checkSaasBlock, 14400000);
      checkSaasBlock();
      return () => {
        clearInterval(saasExpiryToken, saasBlockToken);
      };
    }
  }, [authUserInfo, expiry]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Set the initial online status based on the window.navigator.onLine property.
      setIsOnline(window.navigator.onLine);

      // Add online/offline event listeners.
      const onlineHandler = () => {
        setIsOnline(true);
      };

      const offlineHandler = () => {
        setIsOnline(false);
      };

      window.addEventListener("online", onlineHandler);
      window.addEventListener("offline", offlineHandler);

      return () => {
        // Remove event listeners when the component unmounts.
        window.removeEventListener("online", onlineHandler);
        window.removeEventListener("offline", offlineHandler);
      };
    }
  }, []);


  return (
    <>
      <ToastContainer />
      <audio id="myAudio" preload="none"><source src="/assets/beep/beep.mp3" type="audio/mpeg" /></audio>
      <audio id="myAudioNew" preload="none"><source src="/assets/beep/beep2.mp3" type="audio/mpeg" /></audio>
      <audio id="myAudioPhoneRing" preload="none"><source src="/assets/beep/notify.mp3" type="audio/mpeg" /></audio>
      <audio id="myAudioOrder" preload="none"><source src="/assets/beep/order.mp3" type="audio/mpeg" /></audio>
      <BuildModal
        restaurantModal={restaurantModal}
        setRestaurantModal={setRestaurantModal}
      />
      <TopBarOffline online={isOnline} />
      {SAAS_APPLICATION == "YES"
        ? [
          // apiFailed ? [<SaasApiFailure />] : [
          expiry ? (
            [
              saasBlock == false ? (
                [
                  <React.Fragment key="main">
                    <Navbar />
                    <Switch>


                      {/* installation */}
                      {credentials.install_no && (
                        <Route path="/installation" exact>
                          <Welcome />
                        </Route>
                      )}

                      {credentials.install_no && (
                        <Route path="/installation/permission-chcek" exact>
                          <InstallPermission />
                        </Route>
                      )}

                      {credentials.install_no && (
                        <Route path="/installation/database-setup" exact>
                          <DbSetup />
                        </Route>
                      )}

                      {credentials.install_no && (
                        <Route path="/installation/import-database" exact>
                          <ImportDb />
                        </Route>
                      )}

                      {credentials.install_no && (
                        <Route path="/installation/add-admin-user" exact>
                          <InstallationUser />
                        </Route>
                      )}

                      {credentials.install_no && (
                        <Route path="/installation/congratulation" exact>
                          <InstallationCongratulation />
                        </Route>
                      )}

                      {/* common */}
                      <Route path="/refresh" exact>
                        <Refresh />
                      </Route>

                      <Route path="/login" exact>
                        <Login />
                      </Route>

                      <Route path="/feedback/:id" exact>
                        <Feedback />
                      </Route>
                      {/* <Route path="/sign-up" exact>
                          <SignUp />
                        </Route> */}

                      <Route path="/delivery-man-registration" exact>
                        <BeDeliveryMan />
                      </Route>

                      <Route path="/reset-password" exact>
                        <ForgetPw />
                      </Route>

                      {/* <Route path="/set-new-password/:token" exact>
                        <SetNewPw />
                      </Route> */}

                      {credentials.install_no ? (
                        <Route path="/" exact>
                          <Login />
                        </Route>
                      ) : (
                        <Route path="/" exact>
                          <Login />
                          {/* <RestaurantLanding /> */}
                        </Route>
                      )}

                      {/* Customer routes */}

                      <Route path={["/digital-menu/:id", "/digital-menu/:id/:tableName", "/digital-menu/:id/:tableName/:orderType"]} exact>
                        {
                          generalSettings ? (
                            parseInt(getSystemSettings(generalSettings, "self_order_check")) ? (
                              <DigitalMenu />
                            ) : (
                              <NotFound />
                            )
                          ) : (
                            <NoPermission />
                          )
                        }
                      </Route>

                      <CustomerRoute path="/profile" exact>
                        <CustomerProfile />
                      </CustomerRoute>
                      <CustomerRoute path="/my-orders" exact>
                        <MyOrders />
                      </CustomerRoute>

                      {/* restaurant dashboard pages */}
                      <RestaurantRoute path="/dashboard" exact>
                        <RestaurantHome />
                      </RestaurantRoute>

                      {/* {authUserInfo && authUserInfo?.details !== null ? */}
                      <Route path="/sales-listing" exact>
                        <SalesListing />
                      </Route>

                      <RestaurantRoute path="/update-user-profile" exact>
                        <UpdateProfile />
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/work-periods" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Work period"
                          ) ? (
                          <WorkPeriod />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/closing-stock/:started_at"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Work period"
                          ) ? (
                          <OpeningClosingStock />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <Route path="/order-details/:id" exact>
                        <OrderDelivery />
                      </Route>

                      <PosOrderRoute path="/dashboard/pos" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "POS") ? (
                          (getSystemSettings(generalSettings, "pos_ui_screen") === "modern") ? (
                            <NewPos />
                          ) : (
                            <Pos />
                          )
                        ) : (
                          <NoPermission />
                        )}
                      </PosOrderRoute>

                      <PosOrderRoute path="/dashboard/epos/:order_id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "POS") ? (
                          (getSystemSettings(generalSettings, "pos_ui_screen") === "modern") ? (
                            <NewPos />
                          ) : (
                            <Pos />
                          )
                        ) : (
                          <NoPermission />
                        )}
                      </PosOrderRoute>

                      {/* <RestaurantRoute path="/dashboard/pos" exact>
                          {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "POS") ? (
                            <Pos />
                          ) : (
                            <NoPermission />
                          )}
                        </RestaurantRoute> */}

                      {/* <RestaurantRoute path="/dashboard/epos/{:editId}" exact>
                          {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "POS") ? (
                            <EditSubmittedOrder />
                          ) : (
                            <NoPermission />
                          )}
                        </RestaurantRoute> */}

                      {/* jtd */}
                      {/* <RestaurantRoute
                          path="/dashboard/edit-submit-order/:editId"
                          exact
                        >
                          {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "POS") ? (
                            <EditSubmittedOrder />
                          ) : (
                            <NoPermission />
                          )}
                        </RestaurantRoute> */}

                      <PosOrderRoute path="/dashboard/pos/submitted" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "POS") ? (
                          <Submitted />
                        ) : (
                          <NoPermission />
                        )}
                      </PosOrderRoute>

                      <PosOrderRoute path="/dashboard/pos/foodpanda" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "POS") ? (
                          <FoodPanda />
                        ) : (
                          <NoPermission />
                        )}
                      </PosOrderRoute>

                      <PosOrderRoute path="/dashboard/pos/settled" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "POS") ? (
                          <Settled />
                        ) : (
                          <NoPermission />
                        )}
                      </PosOrderRoute>

                      <PosOrderRoute
                        path="/dashboard/pos/online-orders"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "POS") ? (
                          <OnlineOrders />
                        ) : (
                          <NoPermission />
                        )}
                      </PosOrderRoute>

                      <PosOrderRoute
                        path="/dashboard/pos/pre-orders"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "POS") ? (
                          <PreOrders />
                        ) : (
                          <NoPermission />
                        )}
                      </PosOrderRoute>

                      <RestaurantRoute path="/dashboard/orders" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Order history"
                          ) ? (
                          <OrderHistories />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/online-orders" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Order history"
                          ) ? (
                          <OnlineOrderHistories />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/customers" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Customer"
                          ) ? (
                          <Customers />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/online-customers"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Customer"
                          ) ? (
                          <OnlineCustomerList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/kitchen" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Kitchen"
                          ) ? (
                          <Kitchen />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/kitchen/online" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Kitchen"
                          ) ? (
                          <KitchenOnline />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/kitchen/dinein" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Kitchen") ? (
                          <KitchenDineIn />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/kitchen/takeaway" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Kitchen") ? (
                          <KitchenTakeaway />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <Dashboard />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/table-view" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <TableDashboard />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/admin-reports" exact>
                        {authUserInfo.permissions !== null &&
                          (authUserInfo.details.user_type === "superAdmin" || authUserInfo.details.user_type === "admin") &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <AdminDashboard />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/costing-reports" exact>
                        {authUserInfo.permissions !== null &&
                          (authUserInfo.details.user_type === "superAdmin" || authUserInfo.details.user_type === "admin") &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <CostingDashboard />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/production-dashboard" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <ProductionDashboard />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/consolidated-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <ConsolitedData />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/consolidate-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <ConsolitedReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/saas-profile" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Saas profile"
                          ) ? (
                          <SaasProfile />
                        ) : (
                          // <Valoto />
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* test purpose */}
                      {/* <Route path='/valoto' exact>
                      <Valoto />
                    </Route> */}

                      <RestaurantRoute path="/dashboard/daily-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <Daily />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/monthly-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <Monthly />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* <RestaurantRoute path="/dashboard/yearly-reports" exact>
                          {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <Yearly />
                          ) : (
                          <NoPermission />
                          )}
                          </RestaurantRoute> */}

                      <RestaurantRoute
                        path="/dashboard/food-items-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <ItemWise />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/all-item-report"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <FoodItemReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/ingredient-report"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <IngredientReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute
                        path="/dashboard/food-group-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <GroupWise />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/branch-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <BranchWise />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/work-period-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <WorkPeriodReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/sales-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <SalesReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/order-tracking-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <OrderTracking />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/sales-summary-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <SalesSummaryReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/weekly-sales-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <WeeklySalesReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute
                        path="/dashboard/foc-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <FocReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/gross-sales-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <GrossSalesReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/tax-sales-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <SalesSyncReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/stock-transfer-raw-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <RawStockTransferReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/menu-mix-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <MenuMixReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/sales-analysis-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <SalesAnalysisReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/supplier-purchase-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <SupplierPurchaseReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute path="/dashboard/reports/invoice-ageing-report" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <InvoiceAgeingReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/consumption-purchase-variance-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Stock Consumption Report") ? (
                          <StockConsumptionPurchaseVarianceReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/ingredient-item-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <IngredientItemReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/call-center-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <CallCenterReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/source-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <SourceWiseReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/customer-order-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <CustomerOrderHistoryReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/food-panda-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <FoodPandaReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/rider-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <RiderReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/waiter-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <WaiteReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/feedback-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <FeedbackReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute path="/dashboard/expense-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <ExpenseReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute path="/dashboard/stock-transfer-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <StockTransferReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute path="/dashboard/stock-issuance-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <StockIssuanceReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute path="/dashboard/store-requisition-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <StoreRequisitionReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute path="/dashboard/stock-adjustment-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <StockAdjustmentReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute path="/dashboard/meezan-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <MeezanReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/cancel-order-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <CancelOrderReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/cancel-made-unmade-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <CancelItemReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/hourly-sales-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <HourlySalesReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/income-statement-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <IncomeStatementReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/daily-cash-sales-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <DailyCashSalesReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/pos-user-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <UserWise />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/dept-tag-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <DeptWise />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/service-charge-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <ServiceChargeWise />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/discount-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <DiscountReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/combined-discount-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <CombinedDiscountReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/sales-tender-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <SalesTenderReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/finished-goods-ledger-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <FinishedGoodsReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/grn-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <GRNReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/purchase-order-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <PurchaseOrderReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/purchase-request-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <PurchaseRequestReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/purchase-invoice-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <PurchaseInvoiceReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/po-to-pi-report" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <PoToPiReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/sale-invoice-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <SaleInvoiceReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/sale-return-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <SaleReturnReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/bank-drop-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <BankDropReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/wastage-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <WastageReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/ingredient-cost-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Item Food Cost Report"
                          ) ? (
                          <IngredientCostReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/closing-stock-reports" exact>
                      {authUserInfo.permissions !== null &&
                        checkPermission(authUserInfo.permissions, "Report") ? (
                          <ClosingStockReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute> 

                      <RestaurantRoute path="/dashboard/purchase-return-report" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                            <PurchaseReturnReport />
                          ) : (
                            <NoPermission />
                          )}
                      </RestaurantRoute> 

                      <RestaurantRoute path={["/dashboard/rcr-reports", "/dashboard/rcr-reports/:id"]} exact>
                        {authUserInfo.permissions !== null &&
                        checkPermission(authUserInfo.permissions, "Report") ? (
                          <RcrReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute> 

                      <RestaurantRoute path="/dashboard/fg-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <FgReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/fg-purchase-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <FgPurchaseReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/fg-movement-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <FgMomentReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/raw-movement-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <RawMomentReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/ingredient-consumption-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <IngredientConsumptionReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/fg-sale-oir-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <FGSaleOrderInvoiceReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/fg-sale-invoice-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <FGSaleInvoiceReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/opening-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <OpeningReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/commission-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <CommisionReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/ingredient-conversion-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <IngredientConversionReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/fg-transfer-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <FgTransferReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/customer-report" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <CustomerReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/fg-discard-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <FgDiscardReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/inventory-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <InventoryReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/deal-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <DealReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/complete-sales" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <CompleteSales />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/stock-ledger-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <StockLedgerReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                        
                      <RestaurantRoute
                        path="/dashboard/multi-branch-analysis-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Report"
                        ) ? (
                          <MultiBranchAnalysis />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/supplier-ledger-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <SupplierLedgerReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/stock-variance-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <StockVarianceReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/actual-ideal-cost-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <ActualIdealCostReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/stock-consumption-reports"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <StockConsumptionReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/srb-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <SrbReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/production-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <ProductionReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/fg-packing-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <FgPackingReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/fg-adjustment-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <FgAdjustmentReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/gift-hamper-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <GiftHamperReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/recipe-reports" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <RecipeReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/customer-screen" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "POS") ? (
                          <CustomerScreen />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/dataverify" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Report") ? (
                          <AdminReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/stock" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <StockDashboard />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/food-stock" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <FoodStockReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/ingredient-stock"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <IngredientStockReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/food-stock/:started_at"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <OpeningClosingStockFoodReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/ingredient-stock/:started_at"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Report"
                          ) ? (
                          <OpeningClosingStockIngredientReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* Manage routes */}
                      {/* food */}
                      <RestaurantRoute
                        path="/dashboard/manage/food/groups"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <GroupCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* <RestaurantRoute path="/dashboard/manage/food/units" exact>
                          {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <UnitCrud />
                          ) : (
                          <NoPermission />
                          )}
                          </RestaurantRoute> */}

                      <RestaurantRoute
                        path="/dashboard/manage/food/variations"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <VariationCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/properties"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PropertyCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        //path="/dashboard/manage/food/properties/:slug"
                        path="/dashboard/manage/food/properties-item"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PropertyItemCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/meal-times"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <MealTimeList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/meal-time/add-new"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <MealTimeAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/meal-time-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <MealTimeAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/complaints/add-new" exact>
                        {authUserInfo.permissions !== null ? (
                          <AddNewComplaint />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/complaints/board" exact>
                        {authUserInfo.permissions !== null ? (
                          <ComplaintBoard />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/complaints/tickets-list" exact>
                        {authUserInfo.permissions !== null ? (
                          <TicketsList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/complaints/resolved-tickets" exact>
                        {authUserInfo.permissions !== null ? (
                          <ResolvedTicketsList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/complaints/complaint-tickets/:id?" exact>
                        {authUserInfo.permissions !== null ? (
                          <ComplaintTickets />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/complaints/complaint-resolve/:id?" exact>
                        {authUserInfo.permissions !== null ? (
                          <ComplaintResolve />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/complaints/ComplaintReport" exact>
                        {authUserInfo.permissions !== null ? (
                          <ComplaintReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/add-new"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 ?
                            <NewFoodItemDeptAction />
                            :
                            <FoodItemCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/department"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FoodDepartmentList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/department-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FoodDepartmentAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/department-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FoodDepartmentAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/addon-restriction"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <AddonRestrictionsCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/add-menu"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <MenuTagCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/food-status"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FoodStatusList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/variant"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <VariantList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/product-type"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <ProductTypeList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/production-unit"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <ProductionUnitList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/flavor"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FlavorList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute
                        path="/dashboard/manage/food/season"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <SeasonList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/manage/food/generic"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <GenericList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/weight"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <WeightList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/comment"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <CommentsList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/comment-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <CommentAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/comment-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <CommentAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/region"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <RegionList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/region-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <RegionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/sub-category"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <SubCategoryList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/sub-category-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SubCategoryAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/weight-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <WeightAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/variant-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <VariantAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/production-unit-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <ProductionUnitAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/flavor-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FlavorActions />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/generic-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GenericAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/season-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SeasonAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/region-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <RegionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/sub-category-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SubCategoryAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/weight-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <WeightAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/variant-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <VariantAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/production-unit-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <ProductionUnitAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/flavor-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FlavorActions />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/generic-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GenericAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/season-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SeasonAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      TaxGroupList,
                      TaxGroupAction,
                      <RestaurantRoute
                        path="/dashboard/manage/food/tax-group"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <TaxGroupList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/tax-group-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <TaxGroupAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/tax-group-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <TaxGroupAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/packing-type"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PackingTypeList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/packing-type-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <PackingTypeAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/packing-type-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <PackingTypeAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/add-schemes"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <SchemesCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/add-schemes-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SchemeCrudAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/food/add-schemes-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SchemeCrudAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/add-cards"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <CardsCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/settings/currency-note" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <CurrencyNoteCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/settings/currency-note-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <CurrencyNoteAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/settings/currency-note-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <CurrencyNoteAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/add-voucher"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <VoucherCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/all-items"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 ? (
                            <FoodItemDeptList />
                          ) :
                            <AllItemList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/edit-item/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 ?
                            <NewFoodItemDeptAction />
                            :
                            <FoodItemEdit />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/food/item-menu-link/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FoodItemMenuBranchLink />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* Stock */}
                      <RestaurantRoute
                        path="/dashboard/manage/stock/food-purchase"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FoodPurchase />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-requisition"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FgRequisitionList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-requisition-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FgRequisitionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-requisition-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FgRequisitionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-requisition-view/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FgRequisitionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-issuance"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FgIssuanceList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-issuance-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FgIssuanceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-issuance-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FgIssuanceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-issuance-view/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FgIssuanceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-purchase"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FGPurchaseList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-invoice-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FgInvoceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-invoice-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FgInvoceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FinishGoods />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <EditFinishGoods />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-history"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FinishGoodsHistory />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-transfer"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishGoodTransfer />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-transfer-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishGoodTransferAdd />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-transfer-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishGoodTransferEdit />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-discard"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishedGoodsDiscard />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-discard-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishedGoodsDiscardAdd />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-discard-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishedGoodsDiscardEdit />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-acceptance"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishGoodsAcceptance />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-acceptance-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishGoodsAcceptanceView />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-acceptance-view/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishGoodsAcceptanceView />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-adjustment"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishGoodsAdjustment />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-packing"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgPackageHistory />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-packing-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgPackingAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-packing/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgPackingAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute
                        path="/dashboard/manage/stock/gift-hampers"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GiftHampers />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/gift-hampers-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GiftHampersAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/gift-hampers/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GiftHampersAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/gift-hampers-return"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                        checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GiftHampersReturn />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/gift-hampers-return-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                        checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GiftHampersReturnAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/gift-hampers-return/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                        checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GiftHampersReturnAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-adjustment-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishGoodsAdjustmentAdd />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/finished-goods-adjustment-view/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FinishGoodsAdjustmentView />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/wastage-food"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <WastageFood />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/wastage-food-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <WastageFoodAction />
                      ) : (
                        <NoPermission />
                      )}
                    </RestaurantRoute>

                    <RestaurantRoute
                      path="/dashboard/manage/stock/wastage-food-edit/:id"
                      exact
                    >
                      {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Manage") ? (
                        <WastageFoodAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/wastage-food-view/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <WastageFoodView />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/ingredient-unit"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <IngredientUnit />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/bulk-update-recipe"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <BulkRecipeUpdate />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/create-recipe"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <CreateRecipe />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/view-recipe"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <ViewRecipe />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-history-food"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FoodPurchaseHistory />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-history-food-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FoodPurchaseEdit />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/food-return"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <FoodReturn />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/ingredient-group"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <IngredientGroup />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/ingredient-item"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <IngredientItem />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/brand"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <BrandList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/manage/stock/brand-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <BrandAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/manage/stock/brand-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <BrandAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/ingredient-limit"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <IngredientItemLimit />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/ingredient-limit-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <IngredientLimitAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/ingredient-limit-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <IngredientLimitAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-invoice-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <IngredientPurchase />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/sale-invoice-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <SaleInvoiceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-order-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <PurchaseOrderAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-invoice"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <IngredientPurchaseHistory />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/sale-invoice"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <SaleInvoiceList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-return"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PurchaseReturnList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-return-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PurchaseReturnAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-return-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PurchaseReturnAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-request"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PurchaseRequestHistory />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-request-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PurchaseRequestAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-request-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PurchaseRequestAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/gate-pass"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <GatePassList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/gate-pass-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <GatePassAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/gate-pass-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <GatePassAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/stock-consumption"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <StockConsumptionList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/stock-consumption-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <StockConsumptionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/stock-consumption-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <StockConsumptionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-invoice-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <IngredientPurchaseEdit />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/sale-invoice-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <SaleInvoiceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-sale-invoice"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgSaleInvoiceList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-sale-invoice-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgSaleInvoiceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-sale-invoice-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgSaleInvoiceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-sale-order"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgSaleOrderList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-sale-order-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgSaleOrderAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-sale-order-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgSaleOrderAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-sale-return"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgSaleReturnList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-sale-return-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgSaleReturnAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/fg-sale-return-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <FgSaleReturnAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/sale-return"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SaleReturnList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/sale-return-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SaleReturnAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/sale-return-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SaleReturnAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-order"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <PurchaseOrderHistory />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/purchase-order-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <PurchaseOrderAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/closing-stock"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <ClosingStockHistory />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/closing-stock-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <ClosingStockAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/closing-stock-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <ClosingStockAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/goods-received-note-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GoodsReceivedNoteAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/goods-received-note-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GoodsReceivedNoteAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/goods-received-note"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GoodsReceivedHistory />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/goods-received-note-dept"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GRNDeptAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/goods-received-note-dept-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GRNDeptAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/goods-received-note-dept"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <GRNDeptList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/recipe-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <RecipeEdit />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/production"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <ProductionList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/add-production"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <ProductionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/edit-production/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <ProductionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/day-end-setting"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <DayEndSetting />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/day-end-setting-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <DayEndSettingAdd />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/day-end-setting-edit/:stock/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <DayEndSettingAdd />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/moving-avg-process"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <MovingAvg />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/audit/rcr-list"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <RcrList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/audit/rcr-leaderboard"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <RcrLeaderboardReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/audit/rcr-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <RcrAuditAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/audit/rcr-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <RcrAuditAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/audit/rcr-question-list"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <RcrQuestionList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/audit/rcr-question-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <RcrQuestionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/audit/rcr-question-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <RcrQuestionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/barcode-print-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <BarcodePrint />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/ingredient-return"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <IngredientReturn />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/ingredient-usage"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <IngredientUsage />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/manage-supplier"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <ManageSupplier />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/manage-new-supplier"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <SupplierAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/manage-edit-supplier/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <SupplierAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/store-requisition" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StoreRequisition />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/store-requisition-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StoreRequisitionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/store-requisition-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StoreRequisitionAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/store-requisition-dept" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StoreRequisitionDept />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/store-requisition-dept-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StoreRequisitionDeptAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/store-requisition-dept-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StoreRequisitionDeptAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-issuance" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockIssuance />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute path="/dashboard/manage/stock/stock-receiving" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockReceiving />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockIssuanceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-receiving-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockReceivingAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-view/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockIssuanceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-receiving-view/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockReceivingAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockIssuanceAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-receiving-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockReceivingAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-dept" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockIssuanceDept />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-dept-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockIssuanceDeptAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-dept-view/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockIssuanceDeptAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-dept-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockIssuanceDeptAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-transfer" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockTransfer />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-transfer-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockTransferAdd />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-transfer-view/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockTransferView />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/opening-stock" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <OpeningStock />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/opening-stock-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <OpeningStockAdd />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/opening-stock-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <OpeningStockEdit />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-adjustment" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockAdjustment />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/stock/stock-adjustment-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <StockAdjustmentAdd />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/supplier-history"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <SupplierHistory />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/stock-out-food"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <StockOutFood />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/stock-out-ingredient"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <StockOutIngredient />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/supplier-payment"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SupplierPayment />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/supplier-payment-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SupplierPaymentAdd />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/supplier-payment-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SupplierPaymentEdit />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* Users */}
                      <RestaurantRoute
                        path="/dashboard/manage/user/customers"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <CustomerCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/user/admin-staff"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <AdminStaffCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/user/till"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <UserTill />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/user/add-till"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <UserTillAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/user/edit-till/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <UserTillAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/user/delivery-men"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <DeliveryMen />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/user/delivery-request"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <NewDeliveryMen />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/user/waiters"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Waiter />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/roles-and-permissions"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Permissions />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* Restaurant */}
                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/branches"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <BranchCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/md-jv"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <MdJv />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/md-integration"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <MDIntegrationList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/md-integration-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <MDIntegrationAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/md-integration-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <MDIntegrationAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/bank-drop"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <BankDropList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/bank-drop-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <BankDropForm />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/stock/bank-drop-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <BankDropForm />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/locations"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <LocationList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/location-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <LocationAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/location-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <LocationAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/areas" 
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <Areas />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/zones"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <Zone />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/zone-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <ZoneAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/zone-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <ZoneAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/reasons"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <ReasonList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/reason-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <ReasonAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/reason-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <ReasonAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/restaurant/branches-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <BranchAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/restaurant/branches-edit/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <BranchAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/kds-setting"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <KdsSettingList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/kds-setting-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <KdsSettingAdd />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/kds-setting-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <KdsSettingEdit />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/order-types"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <OrderTypeCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/table-floor"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <TableFloor />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/tables"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <TableCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* <RestaurantRoute
                          path="/dashboard/manage/restaurant/dept-tags"
                          exact
                        >
                          {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                            <DeptTagCrud />
                          ) : (
                            <NoPermission />
                          )}
                        </RestaurantRoute> */}

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/payment-type"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PaymentTypeCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                        <RestaurantRoute
                          path="/dashboard/manage/restaurant/bank-name"
                          exact
                        >
                          {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                            <BankNameCrud />
                          ) : (
                            <NoPermission />
                          )}
                        </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/restaurant/settlement" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <Settlement />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/restaurant/settlement-add" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SettlementAdd />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/dashboard/manage/restaurant/settlement-view/:id" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <SettlementView />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/manage-party"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Party />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/manage-party-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <PartyAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/manage-party-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <PartyAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute
                        path="/dashboard/expense"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          (checkPermission(authUserInfo.permissions, "Show Expense List")) ? (
                          <ExpenseList />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/manage-expense"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Expense />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/party-history"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PartyHistory />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/restaurant/manage-kot"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <KotCrud />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* Website */}
                      <RestaurantRoute
                        path="/dashboard/manage/website/hero-section"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <HeroSection />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/website/promotions"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Promotions />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* Settings */}
                      <RestaurantRoute
                        path="/dashboard/manage/settings/currencies"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Currency />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/languages"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Lang />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/languages/:code"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Translation />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/smtp-settings"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Smtp />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/email-settings"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <EmailTemplate />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/pos-screen"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <PosScreen />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/general-settings"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                            <General />
                          ) : (
                            <NoPermission />
                          )}
                        </RestaurantRoute>

                        <RestaurantRoute
                          path="/dashboard/manage/settings/location-setup"
                          exact
                        >
                          {authUserInfo.permissions !== null &&
                            checkPermission(
                              authUserInfo.permissions,
                              "Manage"
                            ) ? (
                            <LocationSetup />
                          ) : (
                            <NoPermission />
                          )}
                        </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/web-mapping"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <WebMapping />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/offline-table"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <OfflineTableSync />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/generate-test-controller"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") && authUserInfo?.details?.user_type === "superAdmin" ? (
                          <GenerateTestController />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/show-delivery-menu"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Showdeliveryman />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute path="/hellno" exact>
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <OnlinePayment />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/show-manage-stock-menu"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <ShowManageStock />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/update-settings"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <UpdateSettings />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/manage/settings/update-system"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <UpdateSystem />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* payroll */}
                      <RestaurantRoute
                        path="/dashboard/payroll/department"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Department />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/payroll/department-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <DepartmentAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/payroll/department-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <DepartmentAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/payroll/designation"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <Designation />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/payroll/designation-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <DesignationAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/payroll/designation-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Manage"
                          ) ? (
                          <DesignationAction />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* accounts */}
                      <RestaurantRoute
                        path="/dashboard/accounts/gl-setting"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Accounts"
                          ) ? (
                          <AccountSettings />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/accounts/level-1"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <ChartAccount1 />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/accounts/level-2"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <ChartAccount2 />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/accounts/level-3"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Manage") ? (
                          <ChartAccount3 />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      {/* transaction routes */}
                      <RestaurantRoute
                        path="/dashboard/account/transaction/bank-payment"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <BankPayment />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/cash-payment"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <CashPayment />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/bank-receipt"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <BankReceipt />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/bank-receipt-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <BankRecepitForm />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/bank-receipt-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <BankRecepitForm />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/cash-receipt"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <CashReceipt />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/cash-receipt-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <CashReceiptForm />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/cash-receipt-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <CashReceiptForm />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/journal-voucher"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <JournalVoucher />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/opening-account"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <OpeningAccount />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/bank-payment-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <AddBankPayment />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/bank-payment-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <EditBankPayment />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/cash-payment-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <AddCashPayment />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/cash-payment-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <EditCashPayment />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/journal-voucher-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <AddJournalVoucher />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/journal-voucher-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <EditJournalVoucher />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/opening-account-add"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <AddOpeningAccount />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/transaction/opening-account-edit/:id"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <EditOpeningAccount />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* transaction route end */}

                      {/* Accounts report route start */}
                      <RestaurantRoute
                        path="/dashboard/account/reports/ledger-report"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <LedgerReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/reports/payment-report"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <PaymentReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/account/reports/receipt-report"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <ReceiptReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>


                      <RestaurantRoute
                        path="/dashboard/account/reports/supplier-ledger-report"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <AccountsSupplierLedgerReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/account/reports/accounts-report"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <AccountsReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/account/reports/trial-balance-report"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <TrialBalanceReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/reports/profit-loss-report"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <ProfitAndLossReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/reports/cash-flow-report"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <SalesFlowReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>
                      <RestaurantRoute
                        path="/dashboard/account/reports/balance-sheet-report"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(authUserInfo.permissions, "Accounts") ? (
                          <BalanceSheetReport />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* Accounts report route end */}

                      <RestaurantRoute
                        path="/dashboard/delivery/assigned-orders"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Delivery"
                          ) ? (
                          <AssignedOrders />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      <RestaurantRoute
                        path="/dashboard/delivery/delivered-orders"
                        exact
                      >
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Delivery"
                          ) ? (
                          <DeliveredOrders />
                        ) : (
                          <NoPermission />
                        )}
                      </RestaurantRoute>

                      {/* Error Routing */}
                      <Route component={NotFound} />
                      {/* Error Routing */}
                    </Switch>
                    <Footer />
                  </React.Fragment>,
                ]
              ) : (
                <Blocked />
              ),
            ]
          ) : (
            <NotPermitted />
          ),
          // ]
        ]
        : [
          <React.Fragment key="main">
            <Navbar />
            <Switch>

              {/* installation */}
              {credentials.install_no && (
                <Route path="/installation" exact>
                  <Welcome />
                </Route>
              )}

              {credentials.install_no && (
                <Route path="/installation/permission-chcek" exact>
                  <InstallPermission />
                </Route>
              )}

              {credentials.install_no && (
                <Route path="/installation/database-setup" exact>
                  <DbSetup />
                </Route>
              )}

              {credentials.install_no && (
                <Route path="/installation/import-database" exact>
                  <ImportDb />
                </Route>
              )}

              {credentials.install_no && (
                <Route path="/installation/add-admin-user" exact>
                  <InstallationUser />
                </Route>
              )}

              {credentials.install_no && (
                <Route path="/installation/congratulation" exact>
                  <InstallationCongratulation />
                </Route>
              )}

              {/* common */}
              <Route path="/refresh" exact>
                <Refresh />
              </Route>

              <Route path="/login" exact>
                <Login />
              </Route>

              <Route path="/feedback/:id" exact>
                <Feedback />
              </Route>
              {/* <Route path="/sign-up" exact>
                  <SignUp />
                </Route> */}

              <Route path="/delivery-man-registration" exact>
                <BeDeliveryMan />
              </Route>

              <Route path="/reset-password" exact>
                <ForgetPw />
              </Route>

              {/* <Route path="/set-new-password/:token" exact>
                <SetNewPw />
              </Route> */}

              <Route path="/" exact>
                <Login />
              </Route>
              {/* {credentials.install_no ? (
                  <Route path="/" exact>
                    <Login />
                  </Route>
                ) : (
                  <Route path="/" exact>
                    <RestaurantLanding />
                  </Route>
                )} */}

              {/* Customer routes */}
              <CustomerRoute path="/profile" exact>
                <CustomerProfile />
              </CustomerRoute>

              <Route path={["/digital-menu/:id", "/digital-menu/:id/:tableName", "/digital-menu/:id/:tableName/:orderType"]} exact>
                {
                  generalSettings ? (
                    parseInt(getSystemSettings(generalSettings, "self_order_check")) ? (
                      <DigitalMenu />
                    ) : (
                      <NotFound />
                    )
                  ) : (
                    <NoPermission />
                  )
                }
              </Route>

              <CustomerRoute path="/my-orders" exact>
                <MyOrders />
              </CustomerRoute>

              {/* restaurant dashboard pages */}
              <RestaurantRoute path="/dashboard" exact>
                <RestaurantHome />
              </RestaurantRoute>

              {/* {authUserInfo && authUserInfo?.details !== null ? */}
              <Route path="/sales-listing" exact>
                <SalesListing />
              </Route>

              <RestaurantRoute path="/update-user-profile" exact>
                <UpdateProfile />
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/work-periods" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Work period") ? (
                  <WorkPeriod />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/closing-stock/:started_at"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Work period") ? (
                  <OpeningClosingStock />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <Route path="/order-details/:id" exact>
                <OrderDelivery />
              </Route>

              <PosOrderRoute path="/dashboard/pos" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "POS") ? (
                  (getSystemSettings(generalSettings, "pos_ui_screen") === "modern") ? (
                    <NewPos />
                  ) : (
                    <Pos />
                  )
                ) : (
                  <NoPermission />
                )}
              </PosOrderRoute>

              <PosOrderRoute path="/dashboard/epos/:order_id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "POS") ? (
                  (getSystemSettings(generalSettings, "pos_ui_screen") === "modern") ? (
                    <NewPos />
                  ) : (
                    <Pos />
                  )
                ) : (
                  <NoPermission />
                )}
              </PosOrderRoute>

              {/* jtd */}
              {/* <RestaurantRoute
                  path="/dashboard/edit-submit-order/:editId"
                  exact
                >
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "POS") ? (
                    <EditSubmittedOrder />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute> */}

              <PosOrderRoute path="/dashboard/pos/submitted" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "POS") ? (
                  <Submitted />
                ) : (
                  <NoPermission />
                )}
              </PosOrderRoute>


              <PosOrderRoute path="/dashboard/pos/foodpanda" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "POS") ? (
                  <FoodPanda />
                ) : (
                  <NoPermission />
                )}
              </PosOrderRoute>

              <PosOrderRoute path="/dashboard/pos/settled" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "POS") ? (
                  <Settled />
                ) : (
                  <NoPermission />
                )}
              </PosOrderRoute>

              <PosOrderRoute path="/dashboard/pos/online-orders" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "POS") ? (
                  <OnlineOrders />
                ) : (
                  <NoPermission />
                )}
              </PosOrderRoute>

              <PosOrderRoute path="/dashboard/pos/pre-orders" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "POS") ? (
                  <PreOrders />
                ) : (
                  <NoPermission />
                )}
              </PosOrderRoute>

              <RestaurantRoute path="/dashboard/orders" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Order history") ? (
                  <OrderHistories />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/online-orders" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Order history") ? (
                  <OnlineOrderHistories />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/customers" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Customer") ? (
                  <Customers />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/online-customers" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Customer") ? (
                  <OnlineCustomerList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/kitchen" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Kitchen") ? (
                  <Kitchen />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/kitchen/online" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Kitchen") ? (
                  <KitchenOnline />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/kitchen/dinein" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Kitchen") ? (
                  <KitchenDineIn />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/kitchen/takeaway" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Kitchen") ? (
                  <KitchenTakeaway />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <Dashboard />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/table-view" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <TableDashboard />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/admin-reports" exact>
                {authUserInfo.permissions !== null &&
                  (authUserInfo.details.user_type === "superAdmin" || authUserInfo.details.user_type === "admin") &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Report"
                  ) ? (
                  <AdminDashboard />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/costing-reports" exact>
                {authUserInfo.permissions !== null &&
                  (authUserInfo.details.user_type === "superAdmin" || authUserInfo.details.user_type === "admin") &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Report"
                  ) ? (
                  <CostingDashboard />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/production-dashboard" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <ProductionDashboard />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/consolidated-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Report"
                  ) ? (
                  <ConsolitedData />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/consolidate-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Report"
                  ) ? (
                  <ConsolitedReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/daily-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <Daily />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/monthly-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <Monthly />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* <RestaurantRoute path="/dashboard/yearly-reports" exact>
{authUserInfo.permissions !== null &&#
checkPermission(authUserInfo.permissions, "Report") ? (
<Yearly />
) : (
<NoPermission />
)}
</RestaurantRoute> */}

              <RestaurantRoute path="/dashboard/food-items-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <ItemWise />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/all-item-report" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FoodItemReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/ingredient-report" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <IngredientReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/food-group-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <GroupWise />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/branch-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <BranchWise />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/work-period-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <WorkPeriodReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/sales-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <SalesReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/order-tracking-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Report"
                  ) ? (
                  <OrderTracking />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/sales-summary-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <SalesSummaryReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/weekly-sales-reports"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Report"
                  ) ? (
                  <WeeklySalesReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/foc-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FocReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/gross-sales-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <GrossSalesReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/tax-sales-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <SalesSyncReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/stock-transfer-raw-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <RawStockTransferReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/menu-mix-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <MenuMixReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/sales-analysis-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <SalesAnalysisReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/supplier-purchase-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <SupplierPurchaseReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/reports/invoice-ageing-report" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                    <InvoiceAgeingReport />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute>

                <RestaurantRoute path="/dashboard/consumption-purchase-variance-reports" exact>
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Stock Consumption Report") ? (
                    <StockConsumptionPurchaseVarianceReport />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute>

                <RestaurantRoute path="/dashboard/consumption-purchase-variance-reports" exact>
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Stock Consumption Report") ? (
                    <StockConsumptionPurchaseVarianceReport />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute>


              <RestaurantRoute path="/dashboard/ingredient-item-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <IngredientItemReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/call-center-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <CallCenterReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

                <RestaurantRoute
                  path="/dashboard/multi-branch-analysis-reports"
                  exact
                >
                  {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Report"
                  ) ? (
                    <MultiBranchAnalysis />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/daily-cash-sales-reports"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <DailyCashSalesReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/source-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <SourceWiseReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute path="/dashboard/customer-order-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <CustomerOrderHistoryReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/food-panda-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FoodPandaReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute path="/dashboard/rider-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <RiderReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute path="/dashboard/waiter-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <WaiteReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute path="/dashboard/feedback-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FeedbackReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute path="/dashboard/expense-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <ExpenseReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute path="/dashboard/stock-transfer-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <StockTransferReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute path="/dashboard/stock-issuance-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <StockIssuanceReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/store-requisition-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <StoreRequisitionReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/stock-adjustment-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <StockAdjustmentReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute path="/dashboard/meezan-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <MeezanReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/cancel-order-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <CancelOrderReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/cancel-made-unmade-reports"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <CancelItemReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute path="/dashboard/hourly-sales-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <HourlySalesReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/income-statement-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <IncomeStatementReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/pos-user-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <UserWise />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/dept-tag-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <DeptWise />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/service-charge-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <ServiceChargeWise />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/discount-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <DiscountReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/combined-discount-reports"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Report"
                  ) ? (
                  <CombinedDiscountReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/sales-tender-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <SalesTenderReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/finished-goods-ledger-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FinishedGoodsReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/grn-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <GRNReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/purchase-order-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <PurchaseOrderReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/purchase-request-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <PurchaseRequestReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/po-to-pi-report" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <PoToPiReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/purchase-invoice-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <PurchaseInvoiceReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/sale-invoice-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <SaleInvoiceReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/sale-return-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <SaleReturnReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/bank-drop-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <BankDropReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/wastage-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <WastageReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/ingredient-cost-reports"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Item Food Cost Report"
                  ) ? (
                  <IngredientCostReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/closing-stock-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <ClosingStockReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/purchase-return-report" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <PurchaseReturnReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path={["/dashboard/rcr-reports", "/dashboard/rcr-reports/:id"]} exact>
                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Report") ? (
                  <RcrReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute> 

              <RestaurantRoute path="/dashboard/fg-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FgReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/fg-purchase-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FgPurchaseReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/fg-movement-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FgMomentReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/raw-movement-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <RawMomentReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/ingredient-consumption-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <IngredientConsumptionReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/fg-sale-oir-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FGSaleOrderInvoiceReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/fg-sale-invoice-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FGSaleInvoiceReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/opening-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <OpeningReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/commission-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <CommisionReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/ingredient-conversion-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <IngredientConversionReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/fg-transfer-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FgTransferReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/customer-report" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <CustomerReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/fg-discard-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FgDiscardReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/inventory-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <InventoryReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/deal-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <DealReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/complete-sales" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <CompleteSales />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/stock-ledger-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <StockLedgerReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/supplier-ledger-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <SupplierLedgerReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/stock-variance-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <StockVarianceReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/actual-ideal-cost-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <ActualIdealCostReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/stock-consumption-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <StockConsumptionReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/srb-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <SrbReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/production-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <ProductionReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/fg-packing-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FgPackingReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/fg-adjustment-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FgAdjustmentReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/gift-hamper-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <GiftHamperReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/recipe-reports" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <RecipeReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/customer-screen" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "POS") ? (
                  <CustomerScreen />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/dataverify" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <AdminReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/stock" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <StockDashboard />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/food-stock" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <FoodStockReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/ingredient-stock" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <IngredientStockReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/food-stock/:started_at" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <OpeningClosingStockFoodReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/ingredient-stock/:started_at"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Report") ? (
                  <OpeningClosingStockIngredientReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* Manage routes */}
              {/* food */}
              <RestaurantRoute path="/dashboard/manage/food/groups" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GroupCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/variations" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <VariationCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/properties" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PropertyCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                //path="/dashboard/manage/food/properties/:slug"
                path="/dashboard/manage/food/properties-item"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PropertyItemCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/meal-times" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <MealTimeList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/meal-time/add-new" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <MealTimeAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/meal-time-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <MealTimeAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/complaints/add-new" exact>
                {authUserInfo.permissions !== null ? (
                  <AddNewComplaint />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/complaints/board" exact>
                {authUserInfo.permissions !== null ? (
                  <ComplaintBoard />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/complaints/tickets-list" exact>
                {authUserInfo.permissions !== null ? (
                  <TicketsList />
                ) : (
                  <NoPermission />
                )}
                
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/complaints/resolved-tickets" exact>
                {authUserInfo.permissions !== null ? (
                  <ResolvedTicketsList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/complaints/complaint-tickets/:id?" exact>
                {authUserInfo.permissions !== null ? (
                  <ComplaintTickets />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/complaints/complaint-resolve/:id?" exact>
                {authUserInfo.permissions !== null ? (
                  <ComplaintResolve />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/complaints/ComplaintReport" exact>
                {authUserInfo.permissions !== null ? (
                  <ComplaintReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/add-new" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 ?
                    <NewFoodItemDeptAction />
                    :
                    <FoodItemCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/department" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FoodDepartmentList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/department-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FoodDepartmentAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/department-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FoodDepartmentAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/addon-restriction" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <AddonRestrictionsCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/add-menu" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <MenuTagCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/food/food-status"
                exact
              >
                {authUserInfo.permissions !== null && checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FoodStatusList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/food/comment"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <CommentsList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/comment-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <CommentAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/comment-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <CommentAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/food/region"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <RegionList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/food/sub-category"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SubCategoryList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/food/variant"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <VariantList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>


              <RestaurantRoute
                path="/dashboard/manage/food/weight"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <WeightList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>


              <RestaurantRoute
                path="/dashboard/manage/food/product-type"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <ProductTypeList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/food/production-unit"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ProductionUnitList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/region-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <RegionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/region-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <RegionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/sub-category-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SubCategoryAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/sub-category-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SubCategoryAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/weight-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <WeightAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/variant-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <VariantAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/production-unit-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ProductionUnitAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/production-unit-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ProductionUnitAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/weight-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <WeightAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>


              <RestaurantRoute path="/dashboard/manage/food/variant-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <VariantAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>


              <RestaurantRoute
                path="/dashboard/manage/food/flavor"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FlavorList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/flavor-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FlavorActions />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/flavor-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FlavorActions />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>



              <RestaurantRoute
                path="/dashboard/manage/food/season"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SeasonList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/food/generic"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GenericList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>



              <RestaurantRoute path="/dashboard/manage/food/season-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SeasonAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/generic-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GenericAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>



              <RestaurantRoute path="/dashboard/manage/food/season-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SeasonAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/generic-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GenericAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/food/tax-group"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <TaxGroupList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/tax-group-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <TaxGroupAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/tax-group-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <TaxGroupAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/food/packing-type"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PackingTypeList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/packing-type-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PackingTypeAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/packing-type-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PackingTypeAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/food/add-schemes"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SchemesCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/add-schemes-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SchemeCrudAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/add-schemes-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SchemeCrudAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/add-cards" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <CardsCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/settings/currency-note" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <CurrencyNoteCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/settings/currency-note-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <CurrencyNoteAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/settings/currency-note-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <CurrencyNoteAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/add-voucher" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <VoucherCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/all-items" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 ? (
                    <FoodItemDeptList />
                  ) :
                    <AllItemList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/edit-item/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 ?
                    <NewFoodItemDeptAction />
                    :
                    <FoodItemEdit />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/food/item-menu-link/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FoodItemMenuBranchLink />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* Stock */}
              <RestaurantRoute
                path="/dashboard/manage/stock/bulk-update-recipe"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <BulkRecipeUpdate />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/create-recipe"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <CreateRecipe />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/view-recipe"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ViewRecipe />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>


              <RestaurantRoute
                path="/dashboard/manage/stock/wastage-food"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <WastageFood />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/wastage-food-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                    <WastageFoodAction />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute>

                <RestaurantRoute
                  path="/dashboard/manage/stock/wastage-food-edit/:id"
                  exact
                >
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                    <WastageFoodAction />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/wastage-food-view/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <WastageFoodView />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/ingredient-unit"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <IngredientUnit />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-requisition"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FgRequisitionList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-requisition-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FgRequisitionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-requisition-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FgRequisitionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-requisition-view/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FgRequisitionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-issuance"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FgIssuanceList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-issuance-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FgIssuanceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-issuance-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FgIssuanceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-issuance-view/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FgIssuanceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-purchase"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FGPurchaseList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-invoice-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FgInvoceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-invoice-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FgInvoceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FinishGoods />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <EditFinishGoods />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-history"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <FinishGoodsHistory />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/food-purchase"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FoodPurchase />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-history-food"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FoodPurchaseHistory />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-history-food-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FoodPurchaseEdit />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/food-return"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FoodReturn />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/ingredient-group"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <IngredientGroup />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/ingredient-item"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <IngredientItem />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/brand"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <BrandList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/manage/stock/brand-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <BrandAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/manage/stock/brand-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <BrandAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/ingredient-limit"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <IngredientItemLimit />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/ingredient-limit-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <IngredientLimitAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>


              <RestaurantRoute
                path="/dashboard/manage/stock/ingredient-limit-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <IngredientLimitAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-invoice-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <IngredientPurchase />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/sale-invoice-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SaleInvoiceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-order-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PurchaseOrderAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-invoice"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <IngredientPurchaseHistory />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/sale-invoice"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SaleInvoiceList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-return"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PurchaseReturnList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-return-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PurchaseReturnAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-return-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PurchaseReturnAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-request"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PurchaseRequestHistory />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-request-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PurchaseRequestAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-request-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PurchaseRequestAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/gate-pass"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GatePassList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/gate-pass-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GatePassAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/gate-pass-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GatePassAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/stock-consumption"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockConsumptionList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/stock-consumption-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockConsumptionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/stock-consumption-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockConsumptionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-invoice-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <IngredientPurchaseEdit />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/sale-invoice-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SaleInvoiceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-order"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PurchaseOrderHistory />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/purchase-order-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PurchaseOrderAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>


              <RestaurantRoute
                path="/dashboard/manage/stock/closing-stock"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ClosingStockHistory />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/closing-stock-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ClosingStockAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/closing-stock-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ClosingStockAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-sale-invoice"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgSaleInvoiceList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-sale-invoice-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgSaleInvoiceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-sale-invoice-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgSaleInvoiceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-sale-order"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgSaleOrderList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-sale-order-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgSaleOrderAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-sale-order-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgSaleOrderAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-sale-return"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgSaleReturnList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-sale-return-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgSaleReturnAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-sale-return-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgSaleReturnAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/sale-return"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SaleReturnList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/sale-return-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SaleReturnAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/sale-return-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SaleReturnAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/goods-received-note-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GoodsReceivedNoteAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/goods-received-note-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GoodsReceivedNoteAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/goods-received-note"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GoodsReceivedHistory />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/goods-received-note-dept-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GRNDeptAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/goods-received-note-dept-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GRNDeptAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/goods-received-note-dept"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GRNDeptList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/recipe-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <RecipeEdit />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/production"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <ProductionList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/add-production"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <ProductionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/edit-production/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <ProductionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/day-end-setting"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <DayEndSetting />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/day-end-setting-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <DayEndSettingAdd />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/day-end-setting-edit/:stock/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <DayEndSettingAdd />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/moving-avg-process"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <MovingAvg />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/audit/rcr-list"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <RcrList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/audit/rcr-leaderboard"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <RcrLeaderboardReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/audit/rcr-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <RcrAuditAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/audit/rcr-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <RcrAuditAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/audit/rcr-question-list"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <RcrQuestionList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/audit/rcr-question-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <RcrQuestionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/audit/rcr-question-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <RcrQuestionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/barcode-print-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <BarcodePrint />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/ingredient-return"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <IngredientReturn />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/ingredient-usage"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <IngredientUsage />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/manage-supplier"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ManageSupplier />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/manage-new-supplier"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SupplierAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/manage-edit-supplier/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SupplierAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/store-requisition" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StoreRequisition />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/store-requisition-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StoreRequisitionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/store-requisition-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StoreRequisitionAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/store-requisition-dept" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StoreRequisitionDept />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/store-requisition-dept-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StoreRequisitionDeptAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/store-requisition-dept-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StoreRequisitionDeptAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-issuance" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockIssuance />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-receiving" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockReceiving />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockIssuanceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-receiving-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockReceivingAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-view/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockIssuanceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-receiving-view/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockReceivingAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>



              <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockIssuanceAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-receiving-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockReceivingAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-dept" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockIssuanceDept />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-dept-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockIssuanceDeptAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-dept-view/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockIssuanceDeptAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-issuance-dept-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockIssuanceDeptAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-transfer" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockTransfer />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-transfer-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockTransferAdd />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-transfer-view/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockTransferView />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/opening-stock" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <OpeningStock />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/opening-stock-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <OpeningStockAdd />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/opening-stock-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <OpeningStockEdit />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-adjustment" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockAdjustment />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/stock/stock-adjustment-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockAdjustmentAdd />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/supplier-history"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SupplierHistory />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/stock-out-food"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockOutFood />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/stock-out-ingredient"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <StockOutIngredient />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-transfer"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishGoodTransfer />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-transfer-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishGoodTransferAdd />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-transfer-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishGoodTransferEdit />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-discard"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishedGoodsDiscard />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-discard-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishedGoodsDiscardAdd />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-discard-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishedGoodsDiscardEdit />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-acceptance"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishGoodsAcceptance />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-acceptance-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishGoodsAcceptanceView />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-acceptance-view/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishGoodsAcceptanceView />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-adjustment"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishGoodsAdjustment />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-packing"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgPackageHistory />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-packing-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgPackingAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/gift-hampers"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GiftHampers />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/gift-hampers-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GiftHampersAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/gift-hampers/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <GiftHampersAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

                <RestaurantRoute
                  path="/dashboard/manage/stock/gift-hampers-return"
                  exact
                >
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                    <GiftHampersReturn />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute>

                <RestaurantRoute
                  path="/dashboard/manage/stock/gift-hampers-return-add"
                  exact
                >
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                    <GiftHampersReturnAction />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute>

                <RestaurantRoute
                  path="/dashboard/manage/stock/gift-hampers-return/:id"
                  exact
                >
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                    <GiftHampersReturnAction />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/fg-packing/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FgPackingAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-adjustment-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishGoodsAdjustmentAdd />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/finished-goods-adjustment-view/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <FinishGoodsAdjustmentView />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/supplier-payment"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SupplierPayment />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/supplier-payment-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SupplierPaymentAdd />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/supplier-payment-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SupplierPaymentEdit />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* Users */}
              <RestaurantRoute path="/dashboard/manage/user/customers" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <CustomerCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/user/admin-staff"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <AdminStaffCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/user/till"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <UserTill />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/user/add-till"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <UserTillAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/user/edit-till/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <UserTillAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/user/delivery-men"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <DeliveryMen />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/user/delivery-request"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <NewDeliveryMen />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/user/waiters" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Waiter />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/roles-and-permissions"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Permissions />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* Restaurant */}
              <RestaurantRoute
                path="/dashboard/manage/restaurant/branches"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <BranchCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/md-jv"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <MdJv />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/md-integration"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <MDIntegrationList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/md-integration-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <MDIntegrationAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/md-integration-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <MDIntegrationAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/bank-drop"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <BankDropList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/bank-drop-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <BankDropForm />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/stock/bank-drop-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <BankDropForm />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/locations"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <LocationList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/location-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <LocationAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/location-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <LocationAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/areas"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Areas />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/zones"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Zone />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/zone-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ZoneAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/zone-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ZoneAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/reasons"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ReasonList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/reason-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ReasonAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/reason-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ReasonAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/restaurant/branches-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <BranchAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/restaurant/branches-edit/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <BranchAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/kds-setting"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <KdsSettingList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/kds-setting-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <KdsSettingAdd />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/kds-setting-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <KdsSettingEdit />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/order-types"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <OrderTypeCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/table-floor"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <TableFloor />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/tables"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <TableCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* <RestaurantRoute
                  path="/dashboard/manage/restaurant/dept-tags"
                  exact
                >
                  {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                    <DeptTagCrud />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute> */}

              <RestaurantRoute
                path="/dashboard/manage/restaurant/payment-type"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PaymentTypeCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

                <RestaurantRoute
                  path="/dashboard/manage/restaurant/bank-name"
                  exact
                >
                  {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                    <BankNameCrud />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/restaurant/settlement" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Settlement />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/restaurant/settlement-add" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SettlementAdd />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute path="/dashboard/manage/restaurant/settlement-view/:id" exact>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <SettlementView />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/manage-party"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Party />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/manage-party-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PartyAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/manage-party-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PartyAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>


              <RestaurantRoute
                path="/dashboard/expense"
                exact
              >
                {authUserInfo.permissions !== null &&
                  (checkPermission(authUserInfo.permissions, "Show Expense List")) ? (
                  <ExpenseList />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>


              <RestaurantRoute
                path="/dashboard/manage/restaurant/manage-expense"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Expense />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/party-history"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PartyHistory />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/restaurant/manage-kot"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <KotCrud />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* Website */}
              <RestaurantRoute
                path="/dashboard/manage/website/hero-section"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <HeroSection />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/website/promotions"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Promotions />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* Settings */}
              <RestaurantRoute
                path="/dashboard/manage/settings/currencies"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Currency />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/languages"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Lang />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/languages/:code"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Translation />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/smtp-settings"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Smtp />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/email-settings"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <EmailTemplate />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/pos-screen"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <PosScreen />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/general-settings"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                    <General />
                  ) : (
                    <NoPermission />
                  )}
                </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/location-setup"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <LocationSetup />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/web-mapping"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <WebMapping />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/offline-table"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <OfflineTableSync />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/generate-test-controller"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") && authUserInfo?.details?.user_type === "superAdmin" ? (
                  <GenerateTestController />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/show-delivery-menu"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <Showdeliveryman />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/setup-payment"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <OnlinePayment />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/show-manage-stock-menu"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <ShowManageStock />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/update-settings"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <UpdateSettings />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/manage/settings/update-system"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Manage") ? (
                  <UpdateSystem />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* payroll */}
              <RestaurantRoute
                path="/dashboard/payroll/department"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <Department />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/payroll/department-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <DepartmentAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/payroll/department-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <DepartmentAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/payroll/designation"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <Designation />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/payroll/designation-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <DesignationAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/payroll/designation-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage"
                  ) ? (
                  <DesignationAction />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/*accounts */}
              <RestaurantRoute
                path="/dashboard/accounts/gl-setting"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <AccountSettings />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/accounts/level-1"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <ChartAccount1 />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/accounts/level-2"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <ChartAccount2 />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/accounts/level-3"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <ChartAccount3 />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* transaction routes */}
              <RestaurantRoute
                path="/dashboard/account/transaction/bank-payment"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <BankPayment />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/cash-payment"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <CashPayment />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/journal-voucher"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <JournalVoucher />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/opening-account"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <OpeningAccount />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/bank-payment-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <AddBankPayment />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/bank-payment-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <EditBankPayment />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/cash-payment-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <AddCashPayment />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/cash-payment-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <EditCashPayment />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/bank-receipt"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <BankReceipt />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/bank-receipt-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <BankRecepitForm />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/bank-receipt-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <BankRecepitForm />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/cash-receipt"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <CashReceipt />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/cash-receipt-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <CashReceiptForm />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/cash-receipt-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <CashReceiptForm />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/journal-voucher-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <AddJournalVoucher />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/journal-voucher-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <EditJournalVoucher />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/opening-account-add"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <AddOpeningAccount />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/transaction/opening-account-edit/:id"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <EditOpeningAccount />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              {/* transaction route end */}

              {/* Accounts report route start */}
              <RestaurantRoute
                path="/dashboard/account/reports/ledger-report"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <LedgerReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/reports/payment-report"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <PaymentReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/account/reports/receipt-report"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <ReceiptReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/account/reports/supplier-ledger-report"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <AccountsSupplierLedgerReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/account/reports/accounts-report"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <AccountsReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/reports/trial-balance-report"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <TrialBalanceReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/reports/profit-loss-report"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <ProfitAndLossReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/reports/cash-flow-report"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <SalesFlowReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>
              <RestaurantRoute
                path="/dashboard/account/reports/balance-sheet-report"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Accounts") ? (
                  <BalanceSheetReport />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* Accounts report route end */}

              <RestaurantRoute
                path="/dashboard/delivery/assigned-orders"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Delivery") ? (
                  <AssignedOrders />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              <RestaurantRoute
                path="/dashboard/delivery/delivered-orders"
                exact
              >
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Delivery") ? (
                  <DeliveredOrders />
                ) : (
                  <NoPermission />
                )}
              </RestaurantRoute>

              {/* Error Routing */}
              <Route component={NotFound} />
              {/* Error Routing */}
            </Switch>
            <Footer />
          </React.Fragment>,
        ]}
    </>
  );
}

export default SaasApp;
